module.exports = __webpack_public_path__ + "img/ledger-live-setting-step-two.01bff066.png";